import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import Slide61 from "assets/images/TheSolutionImages/Slide6/Slide61.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Slide6() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);
  const scrollRef = useRef();

  useEffect(() => {
    const checkScroll = () => {
      if (scrollRef.current) {
        const el = scrollRef.current;
        setShowScrollIcon(el.scrollHeight > el.clientHeight && window.innerWidth < 1300);
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
          color: "#FFFFFF",
          "*": {
            color: "#FFFFFF !important",
          },
        }}
      >
        {/* Left - Scrollable Text Block */}
        <MDBox
          flex="1"
          display="flex"
          flexDirection="column"
          height="100%"
          maxHeight="100%"
          pr={1}
          justifyContent="flex-start"
        >
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            SharpWatch® Eco-System
          </h1>

          {/* Scrollable Text Area */}
          <MDBox
            ref={scrollRef}
            fontSize={{ xs: "18px", md: "24px" }}
            lineHeight={1.6}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "300px", md: "none" },
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <div style={{ marginBottom: "16px", fontSize: "24px" }}>
              Now we extend intelligence to the cloud:
            </div>

            {/* Bullet-style indented list */}
            <ul style={{ paddingLeft: "24px", margin: 0, fontSize: "20px" }}>
              <li style={{ marginBottom: "12px" }}>
                Logic Solver enables advanced cloud-based control logic.
              </li>
              <li style={{ marginBottom: "12px" }}>Neural Net provides predictive insights.</li>
              <li style={{ marginBottom: "12px" }}>
                Historian supports both on-prem and cloud analytics.
              </li>
            </ul>
          </MDBox>

          {/* Scroll Icon just below the text scroll area */}
          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                fontSize: "30px",
                color: "#FFFFFF",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "40%" }}
          maxWidth={{ xs: "100%", md: "900px" }}
          mt={{ xs: 3, md: 0 }}
        >
          <img
            src={Slide61}
            alt="SharpWatch Eco-System Cloud"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Bounce Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide6;
